export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_team_manage',
  'conversation_unassigned_manage',
  'conversation_team_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'contact_edit', // Só editar o cadastro do contato (contact_manage também edita)
  'report_manage',
  'knowledge_base_manage',
  'inbox_access', // Nova permissão para ver o SidebarGroup Inbox
  'settings_access', // Nova permissão para ter acesso ao SidebarGroup Settings
  'agents_access', // Nova permissão para ter acesso à aba de agentes
  'hide_resolved_conversations', // Nova permissão para não visualizar conversas resolvidas
  'telephony_reports_access', // Nova permissão para ver Painel/Relatório de Pausas/Histórico da Telefonia
  'whatsapp_voice_reports_access', // Nova permissão para ver Chamadas/Relatório de Pausas/Monitor do WhatsApp Voice
  'conversation_create_block', // Bloqueia o botão/endpoint de Nova Conversa (mesma lógica invertida de hide_resolved_conversations)
  'kanban_access', // Ver menu, quadro e analytics do Kanban
  'kanban_deal_manage', // Criar, editar, mover e arquivar cards (implica kanban_access)
  'kanban_manage', // Funil, fase, automação, passagem, agendamentos, excluir card (implica os dois acima)
  'kanban_analytics_block', // Só o quadro: esconde o Analytics do Kanban (presença bloqueia)
  'kanban_own_deals_only', // Só os cards em que atende (dono ou conversa atribuída); esconde o Analytics
  'chamados_view', // Nova permissão para visualizar Chamados
  'massiva_access', // Nova permissão para acessar a aba Massiva
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_team_manage',
  'conversation_unassigned_manage',
  'conversation_team_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_TEAM_PERMISSIONS = 'conversation_team_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_TEAM_UNASSIGNED_PERMISSIONS =
  'conversation_team_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const CONTACT_EDIT_PERMISSIONS = 'contact_edit';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

// Novas constantes para as permissões adicionadas
export const INBOX_ACCESS_PERMISSIONS = 'inbox_access';

export const SETTINGS_ACCESS_PERMISSIONS = 'settings_access';

export const AGENTS_ACCESS_PERMISSIONS = 'agents_access';

export const HIDE_RESOLVED_CONVERSATIONS_PERMISSIONS =
  'hide_resolved_conversations';

export const TELEPHONY_REPORTS_ACCESS_PERMISSIONS = 'telephony_reports_access';

export const WHATSAPP_VOICE_REPORTS_ACCESS_PERMISSIONS =
  'whatsapp_voice_reports_access';

export const CONVERSATION_CREATE_BLOCK_PERMISSIONS =
  'conversation_create_block';

export const KANBAN_ACCESS_PERMISSIONS = 'kanban_access';

export const KANBAN_DEAL_MANAGE_PERMISSIONS = 'kanban_deal_manage';

export const KANBAN_MANAGE_PERMISSIONS = 'kanban_manage';

export const KANBAN_ANALYTICS_BLOCK_PERMISSIONS = 'kanban_analytics_block';

export const KANBAN_OWN_DEALS_ONLY_PERMISSIONS = 'kanban_own_deals_only';
export const CHAMADOS_VIEW_PERMISSIONS = 'chamados_view';

export const MASSIVA_ACCESS_PERMISSIONS = 'massiva_access';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
      CONVERSATION_TEAM_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      // Sem esta linha a aba some justo pra quem só tem conversation_team_manage
      // — e é a ÚNICA aba onde as conversas do time aparecem.
      CONVERSATION_TEAM_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};
